<template>
  <div class="footer text-center title6">
    <div>
      Powered By
      <img
          alt="abacus white logo"
          class="footer_image"
          src="../../../assets/images/logos/ABACUS_Logo_White.svg"
          style="width: 7rem"
      />
    </div>
    <div v-if="showSub" class="mt-3 tac-font">
      <router-link class="underlined text-primary tac-font" to="/termsofservice"
      >Terms of Service
      </router-link
      >
      and
      <router-link class="underlined text-primary tac-font" to="/privacypolibies"
      >Privacy Policies
      </router-link
      >
    </div>
  </div>
</template>

<script lang="ts">

export default {
  props: {
    showSub: {
      type: Boolean,
      default: false
    },
  }
};
</script>

<style scoped>
.footer_image {
  width: 80px;
  margin-top: -0.3rem;
}
.underlined {
  text-decoration: underline;
}
.footer {
  bottom: 0;
  height: 6rem;
}
@media only screen and (max-width: 900px) {
  .footer {
    width: 100%;
  }
  .underlined {
    font-size: 17px;
    font-weight: 400;
  }
}
.tac-font {
  font-size: 0.7rem !important; ;
}
</style>
